import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'

const InteractorContentPageSearch = () => {
  const pageSearch = useCallback((payload, callback, loading) => {
    ApiService.jsonRequest('/content-page/search', payload, response => {
      if (response.status_code === 200) {
        loading(false)
        callback(response.data)
      }
    })
  }, [])
  return { pageSearch }
}

export default InteractorContentPageSearch
